module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('div', {
    staticClass: "col col-md-6"
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__formFields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly || field.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-6"
  }, [_c('fieldset', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldsDetail), function(field) {
    return [_c(field.component, {
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": true,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data['detailsCar'][field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data['detailsCar'], field['name'], $$v)
        },
        expression: "$data['detailsCar'][field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-12"
  }, [_c('fieldset', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldAmountSection), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-12"
  }, [_c('fieldset', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldICMSSection), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-12"
  }, [_c('fieldset', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldPISSection), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-12"
  }, [_c('fieldset', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldCOFINSSection), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Dados Gerais")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo - Detalhes Tabela "), _c('b', [_vm._v("FIPE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Aquisição")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" ICMS")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" PIS")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" COFINS")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29e711d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/VehicleEntry/Create/CreateVehicleDataForm.vue
// module id = 977
// module chunks = 1